import React, { useContext, useEffect, useState } from "react";
import styles from "../../../form.module.css";
import {
  Button,
  Col,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  DatePicker,
  Typography,
  Table,
  Spin,
} from "antd";
import type { TableProps } from "antd";
import useFetch from "../../../../../hooks/useFetch";
import useToast from "../../../../../hooks/useToast";
import {
  eDocType,
  eFORM_FOR,
  eFORMSTATUS,
  eResultCode,
  eYES_OR_NO,
  INPUT_LENGTH,
} from "../../../../../utils/enum";
import { ToastOpen, ToastType } from "../../../../../state/toast/slice";
import Text, { LanguageContext } from "../../../../../context/language-context";
import { FaCheck } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { UserContext } from "../../../../../context";
import {
  GetFormData,
  getTimeline,
  updateField,
  UploadDocs,
} from "../../../../../utils/api.constant";
import AuthUtil from "../../../../../utils/auth";
import { TFormProps } from "../../../../../types";
import { LoaderContext } from "../../../../../context/loader";
import EncryptUtils from "../../../../../utils/encrypt";
import dayjs from "dayjs";
import Utils from "../../../../../utils";
import {
  allowOnlyNumericInput_onKeyDown,
  disableFutureDates_on_input_date_max,
  disableFutureDates_on_input_month_max,
  numberInputRules,
  validateFile,
} from "../../../../../utils/input.validator";
import { Regex } from "../../../../../utils/validation";
import { CloseOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { stringDateInLanguage } from "../../../../../utils/helperFunctions";
import { Rule } from "antd/es/form";

const formItemLayout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

interface DataType {
  key: string;
  label: string;
  value: JSX.Element | string;
}

const TeacherPartOne = ({
  disabled,
  currentFormId,
  currentUfmId,
}: TFormProps) => {
  const [form] = Form.useForm();
  const isMarried = Form.useWatch("TEACHER_PT1_Q13", form);

  const { post } = useFetch();
  const [imageUrl, setImageUrl] = useState<string>();
  const { onShowToast } = useToast();
  const navigate = useNavigate();
  const [formId, setFormId] = useState<string | null>(null);
  const [ufmId, setUfmId] = useState<string | null>(null);
  const [formFor, setFormFor] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [timeLine, setTimeLine] = useState<any>([]);
  const { user } = useContext(UserContext);
  const { userLanguage, userLanguageChange } = useContext(LanguageContext);
  const [documentsData, setDocumentsData] = useState<any>([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [certificateId, setCertificateId] = useState<string | null>(null);
  const [ceoSignId, setCeoSignId] = useState<string | null>(null);
  const [applicantSignId, setApplicantSignId] = useState<string | null>(null);
  const [applyPdfStyles, setApplyPdfStyles] = useState(false);

  // Loader Context For show Loader
  const contextForLoader = useContext(LoaderContext);
  const { isLoading, setIsLoading } = contextForLoader as any;
  const inputRequiredBasicRule: Rule[] = [
    {
      required: true,
      message: Text({ tid: "REQUIRED", def: "Required" }),
    },
  ];
  const vedMapping = {
    [Text({ tid: "RIGVEDA", def: "Rigveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_SHAKALA", def: "Shakala" }),
        Text({ tid: "SHAKHA_BASHKALA", def: "Bashkala" }),
        Text({ tid: "SHAKHA_SHANKHAYANA", def: "Shankhayana" }),
      ],
    },
    [Text({ tid: "SHUKLA_YAJURVEDA", def: "Shukla Yajurveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_KANVA", def: "Kanva" }),
        Text({ tid: "SHAKHA_MADHYANDINA", def: "Madhyandina" }),
      ],
    },
    [Text({ tid: "KRISHNA_YAJURVEDA", def: "Krishna Yajurveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_TAITTIRIYA", def: "Taittiriya" }),
        Text({ tid: "SHAKHA_MAITRAYANI", def: "Maitrayani" }),
      ],
    },
    [Text({ tid: "SAMAVEDA", def: "Samaveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_KAUTHUMA", def: "Kauthuma" }),
        Text({ tid: "SHAKHA_JAIMINIYA", def: "Jaiminiya" }),
        Text({ tid: "SHAKHA_RANAYANIYA", def: "Ranayaniya" }),
      ],
    },
    [Text({ tid: "ATHARVAVEDA", def: "Atharvaveda" })]: {
      vedashakhas: [
        Text({ tid: "SHAKHA_SHAUNAKA", def: "Shaunaka" }),
        Text({ tid: "SHAKHA_PAIPPALADA", def: "Paippalada" }),
      ],
    },
  };

  const [vedOptions, setVedOptions] = useState<any>(vedMapping);

  const handleFieldChange = async (
    field: string,
    value: any,
    bulkPayload?: any,
    isSubmitted?: boolean
  ) => {
    if (formId?.length && ufmId?.length) {
      try {
        setIsSubmitting(true);
        const payload: any = {
          data: {
            id: formId,
            userFormMappingId: ufmId,
          },
        };
        if (field.length > 0) {
          const trimmedValue = value.trim();
          if (trimmedValue.length) {
            payload.data[field] = trimmedValue || "";
          } else {
            form.setFieldValue(field, "");
            return;
          }
        }
        if (bulkPayload) {
          payload.data = {
            ...payload.data,
            ...bulkPayload,
          };
        }
        if (isSubmitted) {
          payload.data.isSubmitted = true;
        }
        const response = await post(updateField, payload);
        const { dataResponse } = response;
        const { returnCode, description } = dataResponse;
        if (returnCode == eResultCode.SUCCESS) {
          setIsLoading(false);
          if (isSubmitted) {
            onShowToast({
              type: ToastType.success,
              title: <FaCheck />,
              position: ToastOpen.leftBottom,
              content: "Form Submitted Successfully!",
            });
            setTimeout(() => {
              navigate("/");
            }, 1000);
          }
        } else if (returnCode == eResultCode.INVALID_REQUEST) {
          onShowToast({
            type: ToastType.error,
            title: <ExclamationCircleOutlined />,
            position: ToastOpen.leftBottom,
            content: description,
          });
        }
      } catch (error) {
        console.error(error);
        setIsSubmitting(false);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const getFormData = async () => {
    setIsLoading(true);
    try {
      const payload: any = {
        data: {
          id: formId,
          userFormMappingId: ufmId,
          isPtOne: true,
          year: 2025
        },
      };

      const response = await post(GetFormData, payload);
      const { dataResponse, data } = response;
      const { returnCode, description } = dataResponse;
      if (returnCode == eResultCode.SUCCESS) {
        const formData = Object.values(data?.teacherPt1Forms || {}).every(
          (value) => value === null
        )
          ? {}
          : data?.teacherPt1Forms || {};

        // List of fields to exclude (file input fields)
        const jsonStringFields = ["TEACHER_PT1_Q24", "TEACHER_PT1_Q31"];
        const fileFields = [
          "TEACHER_PT1_Q42",
          "TEACHER_PT1_Q38",
          "TEACHER_PT1_Q20",
        ];
        const yearFields = ["TEACHER_PT1_Q18"];

        const formattedData = Object.keys(formData).reduce(
          (acc: { [key: string]: any }, key) => {
            if (jsonStringFields.includes(key)) {
              try {
                const parsedArr = formData[key]
                  ? JSON.parse(formData[key])
                  : [{}];
                acc[key] = parsedArr;
              } catch (error) {
                console.error(error);
              }
            } else if (fileFields.includes(key)) {
              acc[key] = "";
            } else if (yearFields.includes(key)) {
              acc[key] = dayjs(formData[key], "YYYY").isValid()
                ? dayjs(formData[key], "YYYY")
                : formData[key];
            } else {
              acc[key] = formData[key];
            }
            return acc;
          },
          {}
        );

        if (formattedData) {
          form.setFieldsValue(formattedData);
        }
        setDocumentsData(data?.documents);
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const [isUploading, setIsUploading] = useState<Boolean>(false);

  const uploadDocument = async (
    file: File,
    type: eDocType,
    documentName?: string
  ) => {
    try {
      setIsUploading(true);
      const formData = new FormData();
      formData.append("file", file);
      formData.append("docType", type.toString());
      formData.append("ufmId", ufmId || "");
      formData.append("userId", user?.id?.toString() || "");
      formData.append("labelName", documentName || "");
      formData.append("currentStage", eFORMSTATUS.STAGE1INPROGRESS.toString());
      const response = await fetch(
        `${process.env.REACT_APP_PUBLIC_API_BASEURL}${UploadDocs}`,
        {
          method: "POST",
          body: formData,
          headers: { ...AuthUtil.getToken() },
        }
      );
      const res = await response.json();
      const { data, dataResponse } = res;
      const { returnCode, description } = dataResponse;

      if (returnCode == eResultCode.SUCCESS) {
        setIsUploading(false);
        switch (documentName) {
          case "TEACHER_PT1_Q38":
            setApplicantSignId(data.docUrl.toString());
            break;
          case "TEACHER_PT1_Q42":
            setCeoSignId(data.docUrl.toString());
            break;
          case "TEACHER_PT1_Q20":
            setCertificateId(data.docUrl.toString());
            break;
          default:
            break;
        }
        return data.docUrl.toString();
      } else {
        setIsUploading(false);
        console.error("Failed to upload images", response.statusText);
      }
    } catch (error) {
      setIsUploading(false);
      console.error(error);
    }
  };

  const tableColumns: TableProps<DataType>["columns"] = [
    {
      title: Text({ tid: "EDUCATION_LEVEL", def: "EDUCATION_LEVEL" }),
      dataIndex: "label",
      key: "label",
    },
    {
      title: Text({ tid: "STUDENT_COUNT", def: "STUDENT_COUNT" }),
      dataIndex: "value",
      key: "value",
      render: (_, record) => (
        <Form.Item
          name={record.key} // Assuming 'key' is unique for each field
          rules={inputRequiredBasicRule}
        >
          <Input
            disabled={disabled || record.key === "TEACHER_PT1_Q29_TOTAL"}
            onBlur={(e) => {
              handleFieldChange(record.key, e.target.value ?? "");
              handleFieldChange(
                "TEACHER_PT1_Q29_TOTAL",
                form.getFieldValue("TEACHER_PT1_Q29_TOTAL")
              );
            }}
            onChange={() => {
              const total = [
                "TEACHER_PT1_Q29_MULANT",
                "TEACHER_PT1_Q29_LEVEL_1",
                "TEACHER_PT1_Q29_LEVEL_2",
                "TEACHER_PT1_Q29_UCCHTAR",
              ]
                .map((field) => parseInt(form.getFieldValue(field)) || 0)
                .reduce((acc, curr) => acc + curr, 0);
              form.setFieldValue("TEACHER_PT1_Q29_TOTAL", total);
            }}
            onKeyDown={allowOnlyNumericInput_onKeyDown}
          />
        </Form.Item>
      ),
    },
  ];

  const TEACHER_PT1_Q28: DataType[] = [
    {
      key: "TEACHER_PT1_Q28_MULANT",
      label: Text({ tid: "MULANT", def: "MULANT" }),
      value: "TEACHER_PT1_Q28_MULANT",
    },
    {
      key: "TEACHER_PT1_Q28_LEVEL_1",
      label: Text({ tid: "LEVEL_1", def: "LEVEL_1" }),
      value: "TEACHER_PT1_Q28_LEVEL_1",
    },
    {
      key: "TEACHER_PT1_Q28_LEVEL_2",
      label: Text({ tid: "LEVEL_2", def: "LEVEL_2" }),
      value: "TEACHER_PT1_Q28_LEVEL_2",
    },
    {
      key: "TEACHER_PT1_Q28_UCCHTAR",
      label: Text({ tid: "UCCHTAR", def: "UCCHTAR" }),
      value: "TEACHER_PT1_Q28_UCCHTAR",
    },
  ];

  const TEACHER_PT1_Q29: DataType[] = [
    {
      key: "TEACHER_PT1_Q29_MULANT", // Unique key for each field
      label: Text({ tid: "MULANT", def: "MULANT" }),
      value: "TEACHER_PT1_Q29_MULANT", // Placeholder or initial value
    },
    {
      key: "TEACHER_PT1_Q29_LEVEL_1",
      label: Text({ tid: "LEVEL_1", def: "LEVEL_1" }),
      value: "TEACHER_PT1_Q29_LEVEL_1",
    },
    {
      key: "TEACHER_PT1_Q29_LEVEL_2",
      label: Text({ tid: "LEVEL_2", def: "LEVEL_2" }),
      value: "TEACHER_PT1_Q29_LEVEL_2",
    },
    {
      key: "TEACHER_PT1_Q29_UCCHTAR",
      label: Text({ tid: "UCCHTAR", def: "UCCHTAR" }),
      value: "TEACHER_PT1_Q29_UCCHTAR",
    },
    {
      key: "TEACHER_PT1_Q29_TOTAL",
      label: Text({ tid: "TOTAL", def: "TOTAL" }),
      value: "TEACHER_PT1_Q29_TOTAL",
    },
  ];

  useEffect(() => {
    const fieldsToInitialize = ["TEACHER_PT1_Q24", "TEACHER_PT1_Q31"];

    fieldsToInitialize.forEach((field) => {
      if (
        !form.getFieldValue(field) ||
        form.getFieldValue(field)?.length === 0
      ) {
        form.setFieldsValue({ [field]: [{}] });
      }
    });
  }, []);

  useEffect(() => {
    if (formId?.length && ufmId?.length) {
      getFormData();
    }
  }, [formId, ufmId]);

  useEffect(() => {
    const documentFields = [
      { id: certificateId, field: "TEACHER_PT1_Q20" },
      { id: ceoSignId, field: "TEACHER_PT1_Q42" },
      { id: applicantSignId, field: "TEACHER_PT1_Q38" },
    ];

    documentFields.forEach(({ id, field }) => {
      if (id) {
        handleFieldChange(field, id);
      }
    });
  }, [certificateId, ceoSignId, applicantSignId]);

  useEffect(() => {
    if (searchParams) {
      const formId = EncryptUtils.decrypt(searchParams.get("id") || "");
      const ufmId = EncryptUtils.decrypt(searchParams.get("ufmid") || "");
      const formFor = EncryptUtils.decrypt(searchParams.get("ff") || "");
      setFormId(formId);
      setUfmId(ufmId);
      setFormFor(formFor);
    }
    if (currentFormId && currentUfmId) {
      setFormId(EncryptUtils.decrypt(currentFormId));
      setUfmId(EncryptUtils.decrypt(currentUfmId));
    }
  }, [searchParams, currentFormId, currentUfmId]);

  const TEACHER_PT1_Q24_A1 = Text({ tid: "TEACHER_PT1_Q24_A1", def: " " });
  const TEACHER_PT1_Q24_A2 = Text({ tid: "TEACHER_PT1_Q24_A2", def: " " });
  const TEACHER_PT1_Q24_B = Text({ tid: "TEACHER_PT1_Q24_B", def: " " });
  const TEACHER_PT1_Q24_C = Text({ tid: "TEACHER_PT1_Q24_C", def: " " });
  const TEACHER_PT1_Q24_D = Text({ tid: "TEACHER_PT1_Q24_D", def: " " });

  const TEACHER_PT1_Q31_A = Text({ tid: "TEACHER_PT1_Q31_A", def: " " });
  const TEACHER_PT1_Q31_B = Text({ tid: "TEACHER_PT1_Q31_B", def: " " });
  const TEACHER_PT1_Q31_C = Text({ tid: "TEACHER_PT1_Q31_C", def: " " });
  const TEACHER_PT1_Q31_D = Text({ tid: "TEACHER_PT1_Q31_D", def: " " });

  const MULANT = Text({ tid: "MULANT", def: "MULANT" });
  const LEVEL_1 = Text({ tid: "LEVEL_1", def: "LEVEL_1" });
  const LEVEL_2 = Text({ tid: "LEVEL_2", def: "LEVEL_2" });
  const UCCHTAR = Text({ tid: "UCCHTAR", def: "UCCHTAR" });

  const REQUIRED = Text({ tid: "REQUIRED", def: "Required" });
  const YES = Text({ tid: "YES", def: "Yes" });
  const NO = Text({ tid: "NO", def: "No" });
  const DESC = Text({ tid: "DESC", def: " " });
  const PREVIEW = Text({ tid: "PREVIEW", def: "Preview" });

  const DROPDOWN_PLACEHOLDER = Text({
    tid: "DROPDOWN_PLACEHOLDER",
    def: "DROPDOWN_PLACEHOLDER",
  });

  const REMOVE = Text({ tid: "REMOVE", def: " " });
  const ADD = Text({ tid: "ADD", def: " " });
  const ATTACHED_DOC = Text({
    tid: "ATTACHED_DOCUMENT",
    def: "Attached Document",
  });

  const [samvedShakhaOptions, setSamvedShakhaOptions] = useState<string[]>([]);
  useEffect(() => {
    setVedOptions(vedMapping);
  }, [userLanguage]);

  const handleGeneratePDF = (id: string, fileName: string) => {
    setApplyPdfStyles(true);
    setTimeout(() => {
      Utils.generatePDF(id, fileName);
      setApplyPdfStyles(false);
    }, 0);
  };

  const LengthCounter: React.FC<{
    form: any;
    fieldName: string | string[];
  }> = ({ form, fieldName }) => {
    // Use useWatch to get real-time updates for the field value
    const fieldValue = Form.useWatch(fieldName, form);

    return (
      <div className='length_counter'>
        {(fieldValue || "").length}/{INPUT_LENGTH.TEXTAREA_LENGTH}
      </div>
    );
  };

  useEffect(() => {
    if (formFor === eFORM_FOR.YOURSELF.toString()) {
      const autoFillData = {
        TEACHER_PT1_Q1: user?.fullName,
        TEACHER_PT1_Q36: user?.fullName,
        TEACHER_PT1_Q40: user?.fullName,
        TEACHER_PT1_Q2: user?.aadhaarCardNumber,
        TEACHER_PT1_Q3: user?.dateOfBirth,
        TEACHER_PT1_Q5: user?.fatherName,
        TEACHER_PT1_Q10: user?.mobileNumber,
        TEACHER_PT1_Q11: user?.emailId,
      };
      form.setFieldsValue(autoFillData);
      handleFieldChange("", "", autoFillData);
    }
  }, [formFor, user]);

  interface TeacherGuidelineTable {
    key: string;
    ved: string;
    level_one: string;
    level_two: string;
  }

  const getTimelineData = async () => {
    try {
      const response = await post(getTimeline, {});
      const { dataResponse, data } = response;
      const { returnCode } = dataResponse;
      if (returnCode === eResultCode.SUCCESS) {
        setTimeLine(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setSamvedShakhaOptions(() => {
      return Object.values(vedMapping).flatMap((item) => item.vedashakhas);
    });
    getTimelineData();
  }, []);

  return (
    <div
      id='teacherFormPart1'
      className={`${styles.formWrapper} studentPartTwo studentTeacherSchoolFormWrapper`}
    >
      <Form
        {...formItemLayout}
        form={form}
        name='register'
        onFinish={() => handleFieldChange("", "", null, true)}
        initialValues={{}}
        scrollToFirstError
        layout='vertical'
      >
        <Row>
          <Flex
            gap='middle'
            align='start'
            justify='space-between'
            style={{ width: "100%" }}
          >
            <Col>
              <Typography.Title level={3}>
                {Text({
                  tid: "TEACHER_PART_1_FORM_HEADING",
                  def: "TEACHER_PART_1_FORM_HEADING",
                })}
              </Typography.Title>
              {!disabled && (
                <Typography.Text type='danger'>
                  {Text({
                    tid: "all_fields_are_mandatory",
                    def: "All fields are mandatory!",
                  })}
                </Typography.Text>
              )}
            </Col>
          </Flex>
        </Row>
        {/* 1. Name */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
            style={{ width: "100%" }}
          >
            <Form.Item
              name='TEACHER_PT1_Q1'
              label={Text({
                tid: "TEACHER_PT1_Q1",
                def: "Name",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) => {
                  handleFieldChange("TEACHER_PT1_Q1", e.target.value);
                  handleFieldChange("TEACHER_PT1_Q36", e.target.value);
                  handleFieldChange("TEACHER_PT1_Q40", e.target.value);
                  form.setFieldValue("TEACHER_PT1_Q36", e.target.value);
                  form.setFieldValue("TEACHER_PT1_Q40", e.target.value);
                }}
                onChange={(e) => {
                  form.setFieldValue("TEACHER_PT1_Q36", e.target.value);
                  form.setFieldValue("TEACHER_PT1_Q40", e.target.value);
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 5. Father's name */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q5'
              label={Text({
                tid: "TEACHER_PT1_Q5",
                def: "Father's name",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q5", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 6. Mother's name */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q6'
              label={Text({
                tid: "TEACHER_PT1_Q6",
                def: "Mother's name",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q6", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 3. DOB */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q3'
              label={Text({
                tid: "TEACHER_PT1_Q3",
                def: "Date of birth",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                type='date'
                disabled={disabled}
                max={disableFutureDates_on_input_date_max()}
                onChange={(e) =>
                  handleFieldChange("TEACHER_PT1_Q3", e.target.value)
                }
                onClick={(e) => e.currentTarget.showPicker()}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 4. Birth Place */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q4'
              label={Text({
                tid: "TEACHER_PT1_Q4",
                def: "Birth Place",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q4", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 7. Rishi-Gotra */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q7'
              label={Text({
                tid: "TEACHER_PT1_Q7",
                def: "Rishi-Gotra",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q7", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 2. Aadhaar Card Number */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q2'
              label={Text({
                tid: "TEACHER_PT1_Q2",
                def: "Aadhaar No.",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: /^[2-9]{1}[0-9]{11}$/, // Aadhaar must be 12 digits and should not start with 0 or 1
                  message: Text({
                    tid: "aadhaar_card_validation",
                    def: "Aadhaar must be 12 digits and should not start with 0 or 1",
                  }),
                },
              ]}
            >
              <Input
                maxLength={12}
                onKeyDown={allowOnlyNumericInput_onKeyDown}
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q2", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 9. Address for correspondence with PIN code */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={12}
          >
            <Form.Item
              name='TEACHER_PT1_Q9'
              label={Text({
                tid: "TEACHER_PT1_Q9",
                def: "Address for correspondence with PIN code",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q9", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q9", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q9'
            />
          </Col>
        </Row>{" "}
        {/* 10. Your mobile number */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q10'
              label={Text({
                tid: "TEACHER_PT1_Q10",
                def: "Your mobile number",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: Regex.MOBILENO, // Updated pattern
                  message: Text({
                    tid: "mobile_number_validation",
                    def: "Enter a valid 10-digit mobile number",
                  }),
                },
              ]}
            >
              <Input
                maxLength={10}
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q10", e.target.value)
                }
                onKeyDown={allowOnlyNumericInput_onKeyDown}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 11. Your email ID */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q11'
              label={Text({
                tid: "TEACHER_PT1_Q11",
                def: "Your email ID",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                  message: Text({
                    tid: "email_validation",
                    def: "Enter a valid email address",
                  }),
                },
              ]}
            >
              <Input
                type='email'
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q11", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 12. In which language should the relevant conversation be conducted with you? */}
        <Row>
          <Col
            xs={24}
            lg={24}
            xl={24}
          >
            <Form.Item
              name='TEACHER_PT1_Q12'
              label={Text({
                tid: "TEACHER_PT1_Q12",
                def: "In which language should the relevant conversation be conducted with you?",
              })}
              rules={inputRequiredBasicRule}
            >
              <Radio.Group
                disabled={disabled}
                onChange={(e) =>
                  handleFieldChange(
                    "TEACHER_PT1_Q12",
                    (e.target as HTMLInputElement).value
                  )
                }
              >
                <Radio value='English'>
                  {Text({ tid: "ENGLISH", def: "English" })}
                </Radio>
                <Radio value='हिन्दी'>
                  {Text({ tid: "HINDI", def: "Hindi" })}
                </Radio>
                <Radio value='संस्कृतम्'>
                  {Text({ tid: "SANSKRIT", def: "Sanskrit" })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        {/* 13. Are you married? */}
        <Row>
          <Col
            xs={24}
            lg={24}
            xl={24}
          >
            <Form.Item
              name='TEACHER_PT1_Q13'
              label={Text({
                tid: "TEACHER_PT1_Q13",
                def: "Are you married?",
              })}
              rules={inputRequiredBasicRule}
            >
              <Radio.Group
                disabled={disabled}
                onChange={(e) =>
                  handleFieldChange(
                    "TEACHER_PT1_Q13",
                    (e.target as HTMLInputElement).value
                  )
                }
              >
                <Radio value='YES'>
                  {Text({ tid: "MARRIED", def: "Married" })}
                </Radio>
                <Radio value='NO'>
                  {Text({ tid: "UNMARRIED", def: "Unmarried" })}
                </Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        {/* 8. swa-ved shakha: */}
        {/* 14. wife's Name */}
        {isMarried === eYES_OR_NO.YES && (
          <Row>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q14'
                label={Text({
                  tid: "TEACHER_PT1_Q14",
                  def: "Mother's name",
                })}
                rules={inputRequiredBasicRule}
              >
                <Input
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange("TEACHER_PT1_Q14", e.target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        )}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q8'
              label={Text({
                tid: "TEACHER_PT1_Q8",
                def: "TEACHER_PT1_Q8",
              })}
              rules={inputRequiredBasicRule}
            >
              {/* <Input
                disabled={disabled}
                onChange={(e) =>
                  handleFieldChange("TEACHER_PT1_Q8", e.target.value)
                }
              /> */}
              <Select
                disabled={disabled}
                onChange={(value) => handleFieldChange("TEACHER_PT1_Q8", value)}
                placeholder={DROPDOWN_PLACEHOLDER}
              >
                {samvedShakhaOptions &&
                  samvedShakhaOptions.map((item: string) => (
                    <Select.Option
                      key={item}
                      value={item}
                    >
                      {item}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 15. Special for Kumaradhyapak: If you are a Kumaradhyapak or you are imparting Ved education in your home, then what is the number of Ved students in your Ved Vidyalaya? */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q15'
              label={Text({
                tid: "TEACHER_PT1_Q15",
                def: "Special for Kumaradhyapak: If you are a Kumaradhyapak or you are imparting Ved education in your home, then what is the number of Ved students in your Ved Vidyalaya?",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                maxLength={10}
                onKeyDown={allowOnlyNumericInput_onKeyDown}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q15", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 15.1). Adhit Vedas : */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q16'
              label={Text({
                tid: "TEACHER_PT1_Q16",
                def: "The Vedas studied:",
              })}
              rules={inputRequiredBasicRule}
            >
              <Select
                disabled={disabled}
                onChange={(value) => {
                  handleFieldChange("TEACHER_PT1_Q16", value);
                  setVedOptions(vedMapping);
                  form.setFieldsValue({ TEACHER_PT1_Q17: "" });
                }}
                placeholder={DROPDOWN_PLACEHOLDER}
              >
                {vedOptions &&
                  Object.keys(vedOptions).map((ved) => (
                    <Select.Option
                      key={ved}
                      value={ved}
                    >
                      {ved}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 15.2). Adhit Vedshakha : */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q17'
              label={Text({
                tid: "TEACHER_PT1_Q17",
                def: "TEACHER_PT1_Q17",
              })}
              rules={inputRequiredBasicRule}
            >
              <Select
                disabled={disabled}
                onChange={(value) =>
                  handleFieldChange("TEACHER_PT1_Q17", value)
                }
                placeholder={DROPDOWN_PLACEHOLDER}
              >
                {vedOptions &&
                  vedOptions[
                    form.getFieldValue("TEACHER_PT1_Q16")
                  ]?.vedashakhas.map((vedashakha: string) => (
                    <Select.Option
                      key={vedashakha}
                      value={vedashakha}
                    >
                      {vedashakha}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        {/* 15.3). Which was the highest exam you passed related to Ved knowledge? : */}
        <Row>
          <Col sm={24}>
            <Typography.Text>
              {Text({
                tid: "TEACHER_PT1_Q18_HEADING",
                def: "Which was the highest exam you passed related to Ved knowledge?",
              })}
            </Typography.Text>
          </Col>
        </Row>
        <div className='QuestionsSubSection'>
          {/* 15.3.1. Name of exam */}
          <Row>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q19'
                label={Text({
                  tid: "TEACHER_PT1_Q19",
                  def: "Name of exam",
                })}
                rules={inputRequiredBasicRule}
              >
                <Input
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange("TEACHER_PT1_Q19", e.target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/*15.3.2 exam cateGORY */}
          <Row>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q18_EXAM_CATEGORY'
                label={Text({
                  tid: "TEACHER_PT1_Q18_EXAM_CATEGORY",
                  def: "Exam category",
                })}
                rules={inputRequiredBasicRule}
              >
                <Input
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange(
                      "TEACHER_PT1_Q18_EXAM_CATEGORY",
                      e.target.value
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 15.3.3. Year */}
          <Row>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q18'
                label={Text({
                  tid: "TEACHER_PT1_Q18",
                  def: "Year",
                })}
                rules={inputRequiredBasicRule}
              >
                <DatePicker
                  disabled={disabled}
                  format='YYYY'
                  onKeyDown={(e) => e.preventDefault()}
                  placeholder={Text({ tid: "SELECT_YEAR", def: "SELECT_YEAR" })}
                  picker='year' // This ensures only years can be selected
                  onChange={(date, dateString) =>
                    handleFieldChange("TEACHER_PT1_Q18", dateString)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 15.3.4. exam center */}
          <Row>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q18_EXAM_INSTITUTE'
                label={Text({
                  tid: "TEACHER_PT1_Q18_EXAM_INSTITUTE",
                  def: "Exam intitute",
                })}
                rules={inputRequiredBasicRule}
              >
                <Input
                  disabled={disabled}
                  onBlur={(e) =>
                    handleFieldChange(
                      "TEACHER_PT1_Q18_EXAM_INSTITUTE",
                      e.target.value
                    )
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          {/* 15.3.3. Attached certificate no */}
          <Row>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q20'
                label={Text({
                  tid: "TEACHER_PT1_Q20",
                  def: "Attach Certificate",
                })}
                rules={[
                  {
                    required:
                      certificateId ||
                      (documentsData?.length &&
                        documentsData?.find(
                          (doc: any) => doc.labelName === "TEACHER_PT1_Q20"
                        ))
                        ? false
                        : true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  disabled={disabled}
                  type='file'
                  // onChange={(e) => {
                  //   if (e.target.files && e.target.files[0]) {
                  //     uploadDocument(
                  //       e.target.files[0],
                  //       eDocType.OTHER,
                  //       "TEACHER_PT1_Q20"
                  //     );
                  //   }
                  // }}
                  accept='.jpg,.jpeg,.png,.pdf'
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!validateFile(file as File).valid) {
                      onShowToast({
                        type: ToastType.error,
                        title: <CloseOutlined />,
                        position: ToastOpen.leftBottom,
                        content: validateFile(file as File).error,
                      });
                      e.target.value = "";
                      form.resetFields(["TEACHER_PT1_Q20"]);
                    } else if (file) {
                      uploadDocument(file, eDocType.OTHER, "TEACHER_PT1_Q20");
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {certificateId ? (
                <div className='previewLink'>
                  <span>
                    {Text({
                      tid: "ATTACHED_DOCUMENT",
                      def: "Attached Document",
                    })}
                    :
                  </span>
                  <a
                    href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${certificateId}`}
                    target='_blank'
                    rel='noreferrer'
                    className='primary-link'
                  >
                    {PREVIEW}
                  </a>
                </div>
              ) : (
                documentsData &&
                documentsData?.length > 0 &&
                documentsData
                  .filter((doc: any) => doc.labelName === "TEACHER_PT1_Q20")
                  .map((doc: any) => (
                    <div className='previewLink'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {doc.docName}
                      </a>
                    </div>
                  ))
              )}
            </Col>
          </Row>
        </div>
        {/* 15.4. Name of your Guru from whom you learnt and passed the above mentioned exam */}
        <Row>
          <Col
            sm={24}
            lg={12}
          >
            <Form.Item
              name='TEACHER_PT1_Q21'
              label={Text({
                tid: "TEACHER_PT1_Q21",
                def: "Name of your Guru from whom you learnt and passed the above mentioned exam",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q21", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 15.5. If the above mentioned Veda teacher is your close relative, please provide details of the family relationship */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q22'
              label={Text({
                tid: "TEACHER_PT1_Q22",
                def: "If the above mentioned Veda teacher is your close relative, please provide details of the family relationship",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q22", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q22", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q22'
            />
          </Col>
        </Row>
        {/* 15.6. Name of your Guru from whom you learnt and passed the above mentioned exam */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q23'
              label={Text({
                tid: "TEACHER_PT1_Q23",
                def: "Have you acquired such Ved knowledge which is considered to be extinct or rare? Give details. (Answer in maximum four lines)",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q23", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q23", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q23'
            />
          </Col>
        </Row>
        {/* 16) Description of your teachings of the Vedas in sequence: */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "TEACHER_PT1_Q24_HEADING",
                def: "1) Description of your teachings of the Vedas in sequence:",
              })}
            </Typography.Text>
            <Form.List name='TEACHER_PT1_Q24'>
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => {
                    return (
                      <Space
                        key={key}
                        align='baseline'
                        className='QuestionsSubSection'
                      >
                        <Row gutter={15}>
                          {/* From Date */}
                          <Col
                            sm={12}
                            lg={8}
                            xl={4}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q24_A1"]}
                              label={TEACHER_PT1_Q24_A1}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                type='month'
                                disabled={disabled}
                                max={disableFutureDates_on_input_month_max()}
                                onClick={(e) => e.currentTarget.showPicker()}
                                onChange={() => {
                                  handleFieldChange(
                                    "TEACHER_PT1_Q24",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q24")
                                    )
                                  );
                                  // Trigger validation of To Date when From Date changes
                                  form.validateFields([
                                    [
                                      [
                                        "TEACHER_PT1_Q24",
                                        name,
                                        "TEACHER_PT1_Q24_A2",
                                      ],
                                    ],
                                  ]);
                                }}
                              />
                            </Form.Item>
                          </Col>

                          {/* To Date */}
                          <Col
                            sm={12}
                            lg={8}
                            xl={4}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q24_A2"]}
                              label={TEACHER_PT1_Q24_A2}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    // Get From Date from the same form item
                                    const fromDate = getFieldValue([
                                      "TEACHER_PT1_Q24",
                                      name,
                                      "TEACHER_PT1_Q24_A1",
                                    ]);
                                    if (value && fromDate && value < fromDate) {
                                      return Promise.reject(
                                        "To date cannot be before From date"
                                      );
                                    }
                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            >
                              <Input
                                type='month'
                                disabled={disabled}
                                onClick={(e) => e.currentTarget.showPicker()}
                                max={disableFutureDates_on_input_month_max()}
                                onChange={() => {
                                  handleFieldChange(
                                    "TEACHER_PT1_Q24",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q24")
                                    )
                                  );
                                  // Trigger validation of From Date when To Date changes
                                  form.validateFields([
                                    [
                                      [
                                        "TEACHER_PT1_Q24",
                                        name,
                                        "TEACHER_PT1_Q24_A1",
                                      ],
                                    ],
                                  ]);
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q24_B"]}
                              label={TEACHER_PT1_Q24_B}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q24",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q24")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q24_C"]}
                              label={TEACHER_PT1_Q24_C}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q24",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q24")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q24_D"]}
                              label={TEACHER_PT1_Q24_D}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q24",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q24")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          {/* Add Remove Button */}
                          <Col xs={24}>
                            <Flex gap={22}>
                              <Form.Item>
                                <Button
                                  variant='filled'
                                  className='actionButton'
                                  disabled={disabled || index === 0}
                                  // onClick={() => remove(name)}
                                  onClick={() => {
                                    // if (
                                    //   form.getFieldValue("TEACHER_PT1_Q24")
                                    //     ?.length > 1
                                    // ) {
                                    remove(name);
                                    handleFieldChange(
                                      "TEACHER_PT1_Q24",
                                      JSON.stringify(
                                        form.getFieldValue("TEACHER_PT1_Q24")
                                      )
                                    );
                                    // }
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                              {form.getFieldValue("TEACHER_PT1_Q24")?.length -
                                1 ===
                                index && (
                                <Form.Item>
                                  <Button
                                    disabled={disabled}
                                    variant='filled'
                                    className='actionButton'
                                    onClick={() => {
                                      add();
                                      handleFieldChange(
                                        "TEACHER_PT1_Q24",
                                        JSON.stringify(
                                          form.getFieldValue("TEACHER_PT1_Q24")
                                        )
                                      );
                                    }}
                                    block
                                  >
                                    {ADD}
                                  </Button>
                                </Form.Item>
                              )}
                            </Flex>
                          </Col>
                        </Row>
                        {form.getFieldValue("TEACHER_PT1_Q24")?.length - 1 >
                          index && <div className='divider'></div>}
                      </Space>
                    );
                  })}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 17). Name and full address of the present institution where you are teaching: */}
        <Row className=''>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q25'
              label={Text({
                tid: "TEACHER_PT1_Q25",
                def: "Name and full address of the present institution where you are teaching",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q25", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q25", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q25'
            />
          </Col>
        </Row>
        {/* 18). Name of the head of the institution: */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q26'
              label={Text({
                tid: "TEACHER_PT1_Q26",
                def: "Name of the head of the institution:",
              })}
              rules={inputRequiredBasicRule}
            >
              <Input
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q26", e.target.value)
                }
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 19). Mobile number of the head of the institution: */}
        <Row>
          <Col
            sm={24}
            lg={12}
            xl={8}
          >
            <Form.Item
              name='TEACHER_PT1_Q27'
              label={Text({
                tid: "TEACHER_PT1_Q27",
                def: "Mobile number of the head of the institution:",
              })}
              rules={[
                {
                  required: true,
                  message: Text({ tid: "REQUIRED", def: "Required" }),
                },
                {
                  pattern: Regex.MOBILENO, // Updated pattern
                  message: Text({
                    tid: "mobile_number_validation",
                    def: "Enter a valid 10-digit mobile number",
                  }),
                },
              ]}
            >
              <Input
                maxLength={10}
                disabled={disabled}
                onBlur={(e) =>
                  handleFieldChange("TEACHER_PT1_Q27", e.target.value)
                }
                onKeyDown={allowOnlyNumericInput_onKeyDown}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 20). Number of students currently studying Vedas with you: */}
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={12}
          >
            <Typography.Text>
              {Text({
                tid: "TEACHER_PT1_Q28_HEADING",
                def: "Number of students currently studying Vedas with you",
              })}
            </Typography.Text>
          </Col>
        </Row>
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={6}
          >
            <Form.Item name='TEACHER_PT1_Q28'>
              <Table<DataType>
                columns={tableColumns}
                size='large'
                dataSource={TEACHER_PT1_Q28}
                pagination={false}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 21). Details of students taught during his entire period of teaching Vedas: */}
        <Row>
          <Col>
            <Typography.Text>
              {Text({
                tid: "TEACHER_PT1_Q29",
                def: "Details of students taught during his entire period of teaching Vedas",
              })}
            </Typography.Text>
          </Col>
        </Row>
        <Row>
          <Col
            xs={24}
            lg={12}
            xl={6}
          >
            <Form.Item name='TEACHER_PT1_Q29'>
              <Table<DataType>
                columns={tableColumns}
                size='large'
                dataSource={TEACHER_PT1_Q29}
                pagination={false}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        {/* 22). Mention the efforts made by you for the study, preservation and promotion of rare or endangered Vedas/Ved knowledge. (Write the answer in maximum four lines): */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q30'
              label={Text({
                tid: "TEACHER_PT1_Q30",
                def: "Mention the efforts made by you for the study, preservation and promotion of rare or endangered Vedas/Ved knowledge. (Write the answer in maximum four lines)",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q30", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q30", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q30'
            />
          </Col>
        </Row>
        {/* 23). Have you made your close relatives study Vedas? If yes, their details: */}
        <Row>
          <Col
            xs={24}
            className='onClickRenderFields'
          >
            <Typography.Text>
              {Text({
                tid: "TEACHER_PT1_Q31_HEADING",
                def: "1) Have you made your close relatives study Vedas? If yes, their details:",
              })}
            </Typography.Text>
            <Form.List name='TEACHER_PT1_Q31'>
              {(fields, { add, remove }) => (
                <>
                  {fields.length === 0 && (
                    <Row>
                      <Col>
                        <Flex>
                          <Form.Item>
                            <Button
                              variant='filled'
                              className='actionButton'
                              disabled={disabled}
                              onClick={() => {
                                add();
                                handleFieldChange(
                                  "TEACHER_PT1_Q31",
                                  JSON.stringify(
                                    form.getFieldValue("TEACHER_PT1_Q31")
                                  )
                                );
                              }}
                              block
                            >
                              {ADD}
                            </Button>
                          </Form.Item>
                        </Flex>
                      </Col>
                    </Row>
                  )}
                  {fields.map(({ key, name, ...restField }, index) => {
                    return (
                      <Space
                        key={key}
                        align='baseline'
                        className='QuestionsSubSection'
                      >
                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q31_A"]}
                              label={TEACHER_PT1_Q31_A}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q31",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q31")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q31_B"]}
                              label={TEACHER_PT1_Q31_B}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q31",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q31")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q31_C"]}
                              label={TEACHER_PT1_Q31_C}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Select
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q31",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q31")
                                    )
                                  )
                                }
                                placeholder={DROPDOWN_PLACEHOLDER}
                              >
                                <Select.Option value={MULANT}>
                                  {MULANT}
                                </Select.Option>
                                <Select.Option value={LEVEL_1}>
                                  {LEVEL_1}
                                </Select.Option>
                                <Select.Option value={LEVEL_2}>
                                  {LEVEL_2}
                                </Select.Option>
                                <Select.Option value={UCCHTAR}>
                                  {UCCHTAR}
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>

                        <Row>
                          <Col
                            sm={24}
                            lg={12}
                            xl={8}
                          >
                            <Form.Item
                              className='w-full'
                              {...restField}
                              name={[name, "TEACHER_PT1_Q31_D"]}
                              label={TEACHER_PT1_Q31_D}
                              rules={[
                                {
                                  required: true,
                                  message: REQUIRED,
                                },
                              ]}
                            >
                              <Input
                                disabled={disabled}
                                onBlur={() =>
                                  handleFieldChange(
                                    "TEACHER_PT1_Q31",
                                    JSON.stringify(
                                      form.getFieldValue("TEACHER_PT1_Q31")
                                    )
                                  )
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row>
                          {/* Add Remove Button */}
                          <Col xs={24}>
                            <Flex gap={22}>
                              <Form.Item>
                                <Button
                                  variant='filled'
                                  className='actionButton'
                                  disabled={disabled}
                                  // onClick={() => remove(name)}
                                  onClick={() => {
                                    remove(name);
                                    handleFieldChange(
                                      "TEACHER_PT1_Q31",
                                      JSON.stringify(
                                        form.getFieldValue("TEACHER_PT1_Q31")
                                      )
                                    );
                                  }}
                                >
                                  {REMOVE}
                                </Button>
                              </Form.Item>
                              {form.getFieldValue("TEACHER_PT1_Q31")?.length -
                                1 ===
                                index && (
                                <Form.Item>
                                  <Button
                                    variant='filled'
                                    disabled={disabled}
                                    className='actionButton'
                                    onClick={() => {
                                      add();
                                      handleFieldChange(
                                        "TEACHER_PT1_Q31",
                                        JSON.stringify(
                                          form.getFieldValue("TEACHER_PT1_Q31")
                                        )
                                      );
                                    }}
                                    block
                                  >
                                    {ADD}
                                  </Button>
                                </Form.Item>
                              )}
                            </Flex>
                          </Col>
                        </Row>
                        {form.getFieldValue("TEACHER_PT1_Q31")?.length - 1 >
                          index && <div className='divider'></div>}
                      </Space>
                    );
                  })}
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        {/* 24). Mention the main efforts made by you for the propagation and preservation of the Vedas. (Write the answer in maximum four lines): */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q32'
              label={Text({
                tid: "TEACHER_PT1_Q32",
                def: "Mention the main efforts made by you for the propagation and preservation of the Vedas. (Write the answer in maximum four lines)",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q32", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q32", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q32'
            />
          </Col>
        </Row>
        {/* 25). Mention the main efforts made by you for the propagation and preservation of the Vedas. (Write the answer in maximum four lines): */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q33'
              label={Text({
                tid: "TEACHER_PT1_Q33",
                def: "Tell us five achievements of your teaching of Vedas that make you proud. (Write the answer in maximum five lines)",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q33", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q33", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q33'
            />
          </Col>
        </Row>
        {/* 26). Describe the qualities of an ideal Veda teacher. (Answer in maximum four lines): */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q34'
              label={Text({
                tid: "TEACHER_PT1_Q34",
                def: "Describe the qualities of an ideal Veda teacher. (Answer in maximum four lines)",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q34", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q34", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q34'
            />
          </Col>
        </Row>
        {/* 27). oday's young generation does not understand the importance of Vedas in their daily lives. How will you explain the importance of Vedas to such people? (Write the answer in maximum four lines) */}
        <Row>
          <Col sm={24}>
            <Form.Item
              name='TEACHER_PT1_Q35'
              label={Text({
                tid: "TEACHER_PT1_Q35",
                def: "Today's young generation does not understand the importance of Vedas in their daily lives. How will you explain the importance of Vedas to such people? (Write the answer in maximum four lines)",
              })}
              rules={inputRequiredBasicRule}
            >
              <>
                <Input.TextArea
                  disabled={disabled}
                  onBlur={(e) => {
                    handleFieldChange("TEACHER_PT1_Q35", e.target.value);
                  }}
                  onChange={(e) => {
                    form.setFieldValue("TEACHER_PT1_Q35", e.target.value);
                  }}
                  maxLength={INPUT_LENGTH.TEXTAREA_LENGTH}
                  style={{ paddingBottom: 20 }}
                />
              </>
            </Form.Item>
            <LengthCounter
              form={form}
              fieldName='TEACHER_PT1_Q35'
            />
          </Col>
        </Row>
        {/* 28) TEACHER_PT1_Q36_AFFIDAVIT_TITLE */}
        <div
          id='tch_form1_teacher_affidavit'
          className='affidavitSection'
        >
          <Row>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_Q36_AFFIDAVIT_TITLE",
                  def: "TEACHER_PT1_Q36_AFFIDAVIT_TITLE",
                })}
              </Typography.Text>
            </Col>
          </Row>

          {/* 29) affidavit declaration */}
          <Row className=' affidavitRow'>
            <Col sm={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginBottom: "var(--bs-label-bottom-margin)",
                }}
              >
                {Text({
                  tid: "TEACHER_PT1_Q36_AFFIDAVIT_DECLARATION_1",
                  def: "I,",
                })}
                <Form.Item
                  name='TEACHER_PT1_Q36'
                  rules={inputRequiredBasicRule}
                  className='affidavitRowInput'
                >
                  <Input
                    disabled={applyPdfStyles ? false : true}
                    onBlur={(e) =>
                      handleFieldChange("TEACHER_PT1_Q36", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
                {Text({
                  tid: "TEACHER_PT1_Q36_AFFIDAVIT_DECLARATION_2",
                  def: "solemnly declare that:",
                })}
              </div>
              <ul className='mb-label'>
                <li>
                  <Typography.Text>
                    {Text({
                      tid: "TEACHER_PT1_Q36_AFFIDAVIT_VED_TEACHER",
                      def: "I am currently a full-time Ved teacher.",
                    })}
                  </Typography.Text>
                </li>
                <li>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    {Text({
                      tid: "TEACHER_PT1_Q36_AFFIDAVIT_YEARS_TEACHING_1",
                      def: "I have been continuously engaged in full-time Ved teaching for the past __ years.",
                    })}
                    <Form.Item
                      name='TEACHER_PT1_Q37'
                      className=' affidavitRowInput'
                      rules={numberInputRules({
                        required: true,
                        allowNegative: false,
                        min: 0,
                        max: 120,
                      })}
                    >
                      <Input
                        disabled={disabled}
                        onBlur={(e) =>
                          handleFieldChange("TEACHER_PT1_Q37", e.target.value)
                        }
                        id={applyPdfStyles ? "affidavit_input" : ""}
                      />
                    </Form.Item>
                    {Text({
                      tid: "TEACHER_PT1_Q36_AFFIDAVIT_YEARS_TEACHING_2",
                      def: "I have been continuously engaged in full-time Ved teaching for the past __ years.",
                    })}
                  </div>
                </li>
                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "TEACHER_PT1_Q36_AFFIDAVIT_INFORMATION_ACCURACY",
                      def: "All the information provided in this application form is completely true.",
                    })}
                  </Typography.Text>
                </li>

                <li>
                  <Typography.Text type='secondary'>
                    {Text({
                      tid: "TEACHER_PT1_Q36_AFFIDAVIT_DOCUMENTS_AUTHENTICITY",
                      def: "All the information in the attached documents is true.",
                    })}
                  </Typography.Text>
                </li>
              </ul>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_Q36_AFFIDAVIT_SIGN_CONFIRMATION",
                  def: "I have signed this affidavit after verifying all the facts.",
                })}
              </Typography.Text>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_Q36_AFFIDAVIT_UNDERSTANDING",
                  def: "I fully understand the significance of signing this affidavit.",
                })}
              </Typography.Text>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_Q36_AFFIDAVIT_DISQUALIFICATION_CONSENT",
                  def: "I acknowledge that if this affidavit is found to be false, I and my students may be permanently disqualified.",
                })}
              </Typography.Text>
            </Col>
          </Row>
          {/* 32) full name */}
          <Row className='QuestionsSubSection affidavitQuestionFirst'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q36_FULL_NAME",
                      def: "TEACHER_PT1_Q36_FULL_NAME",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q40'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      onBlur={(e) =>
                        handleFieldChange("TEACHER_PT1_Q40", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q40'
                  label={Text({
                    tid: "TEACHER_PT1_Q36_FULL_NAME",
                    def: "TEACHER_PT1_Q36_FULL_NAME",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("TEACHER_PT1_Q40", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {/* 31) Teacher location*/}
          <Row className='QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q36_PLACE",
                      def: "TEACHER_PT1_Q36_PLACE",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q39'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      onBlur={(e) =>
                        handleFieldChange("TEACHER_PT1_Q39", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q39'
                  label={Text({
                    tid: "TEACHER_PT1_Q36_PLACE",
                    def: "TEACHER_PT1_Q36_PLACE",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("TEACHER_PT1_Q39", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {/* 33) date */}
          <Row className='QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q36_DATE",
                      def: "TEACHER_PT1_Q36_DATE",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q41'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      type={undefined}
                      disabled={false}
                      onChange={(e) =>
                        handleFieldChange("TEACHER_PT1_Q41", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q41'
                  label={Text({
                    tid: "TEACHER_PT1_Q36_DATE",
                    def: "TEACHER_PT1_Q36_DATE",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    type={applyPdfStyles ? undefined : "date"}
                    max={
                      applyPdfStyles
                        ? undefined
                        : disableFutureDates_on_input_date_max()
                    }
                    disabled={disabled}
                    onChange={(e) =>
                      handleFieldChange("TEACHER_PT1_Q41", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {applyPdfStyles ? (
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "SIGNATURE_OF_THE_APPLICANT",
                      def: "SIGNATURE_OF_THE_APPLICANT",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>
        <div className='affidavitSection'>
          {!disabled && (
            <Row className='mb-15 QuestionsSubSection'>
              <Button
                type='default'
                onClick={() =>
                  handleGeneratePDF(
                    "tch_form1_teacher_affidavit",
                    "teacher_form2_teacher_affidavit"
                  )
                }
                className='downloadAffidavitButton'
              >
                {Text({
                  tid: "DOWNLOAD_AFFIDAVIT",
                  def: "Download affidavit",
                })}
              </Button>
            </Row>
          )}

          {/* 30) TEACHER AFFIDAVIT */}
          <Row className='QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q38'
                label={Text({
                  tid: "UPLOAD_AFFIDAVIT",
                  def: "Upload affidavit",
                })}
                rules={[
                  {
                    required:
                      applicantSignId ||
                      (documentsData?.length &&
                        documentsData.find(
                          (doc: any) => doc.labelName === "TEACHER_PT1_Q38"
                        ))
                        ? false
                        : true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  type='file'
                  disabled={disabled}
                  // onChange={(e) => {
                  //   if (e.target.files && e.target.files[0]) {
                  //     uploadDocument(
                  //       e.target.files[0],
                  //       eDocType.OTHER,
                  //       "TEACHER_PT1_Q38"
                  //     );
                  //   }
                  // }}
                  accept='.jpg,.jpeg,.png,.pdf'
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!validateFile(file as File).valid) {
                      onShowToast({
                        type: ToastType.error,
                        title: <CloseOutlined />,
                        position: ToastOpen.leftBottom,
                        content: validateFile(file as File).error,
                      });
                      e.target.value = "";
                      form.resetFields(["TEACHER_PT1_Q38"]);
                    } else if (file) {
                      uploadDocument(file, eDocType.OTHER, "TEACHER_PT1_Q38");
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {applicantSignId ? (
                <div className='previewLink'>
                  <span>
                    {Text({
                      tid: "ATTACHED_DOCUMENT",
                      def: "Attached Document",
                    })}
                    :
                  </span>
                  <a
                    href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${applicantSignId}`}
                    target='_blank'
                    rel='noreferrer'
                    className='primary-link'
                  >
                    {Text({
                      tid: "PREVIEW",
                      def: "Preview",
                    })}
                  </a>
                </div>
              ) : (
                documentsData &&
                documentsData?.length > 0 &&
                documentsData
                  .filter((doc: any) => doc.labelName === "TEACHER_PT1_Q38")
                  .map((doc: any) => (
                    <div className='previewLink'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {doc.docName}
                      </a>
                    </div>
                  ))
              )}
            </Col>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_POST_Q38",
                  def: "TEACHER_PT1_POST_Q38",
                })}
              </Typography.Text>
            </Col>
          </Row>
        </div>
        {/* 34) TEACHER_PT1_Q36_AFFIDAVIT_TITLE */}
        <div
          id='tch_form2_ceo_affidavit'
          style={{ marginTop: "20px" }}
          className='affidavitSection'
        >
          <Row>
            <Col>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_Q37_AFFIDAVIT_TITLE",
                  def: "TEACHER_PT1_Q37_AFFIDAVIT_TITLE",
                })}
              </Typography.Text>
            </Col>
          </Row>

          {/* 35) affidavit declaration */}
          <Row>
            <Col sm={24}>
              <Typography.Text>
                {Text({
                  tid: "TEACHER_PT1_Q37_CERTIFICATION",
                  def: "TEACHER_PT1_Q37_CERTIFICATION",
                })}
              </Typography.Text>
            </Col>
          </Row>

          {/* 37) Institution Head's Name*/}
          <Row className='QuestionsSubSection affidavitQuestionFirst'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q37_INSTITUTION_HEAD_FULL_NAME",
                      def: "TEACHER_PT1_Q37_INSTITUTION_HEAD_FULL_NAME",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q43'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      onBlur={(e) =>
                        handleFieldChange("TEACHER_PT1_Q43", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q43'
                  label={Text({
                    tid: "TEACHER_PT1_Q37_INSTITUTION_HEAD_FULL_NAME",
                    def: "TEACHER_PT1_Q37_INSTITUTION_HEAD_FULL_NAME",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("TEACHER_PT1_Q43", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {/* 38) Name of the Institution */}
          <Row className='QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q37_INSTITUTION_NAME",
                      def: "TEACHER_PT1_Q37_INSTITUTION_NAME",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q44'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      onBlur={(e) =>
                        handleFieldChange("TEACHER_PT1_Q44", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q44'
                  label={Text({
                    tid: "TEACHER_PT1_Q37_INSTITUTION_NAME",
                    def: "TEACHER_PT1_Q37_INSTITUTION_NAME",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("TEACHER_PT1_Q44", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {/* 40) Place*/}
          <Row className='QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q37_PLACE",
                      def: "TEACHER_PT1_Q37_PLACE",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q45'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      disabled={false}
                      onBlur={(e) =>
                        handleFieldChange("TEACHER_PT1_Q45", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q45'
                  label={Text({
                    tid: "TEACHER_PT1_Q37_PLACE",
                    def: "TEACHER_PT1_Q37_PLACE",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    disabled={disabled}
                    onBlur={(e) =>
                      handleFieldChange("TEACHER_PT1_Q45", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {/* 41) Date */}
          <Row className='QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              {applyPdfStyles ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q37_DATE",
                      def: "TEACHER_PT1_Q37_DATE",
                    })}
                  </span>
                  <Form.Item
                    name='TEACHER_PT1_Q46'
                    rules={inputRequiredBasicRule}
                    style={{ marginBottom: 0, flex: 1 }}
                  >
                    <Input
                      type={undefined}
                      disabled={false}
                      onChange={(e) =>
                        handleFieldChange("TEACHER_PT1_Q46", e.target.value)
                      }
                      id={applyPdfStyles ? "affidavit_input" : ""}
                    />
                  </Form.Item>
                </div>
              ) : (
                <Form.Item
                  name='TEACHER_PT1_Q46'
                  label={Text({
                    tid: "TEACHER_PT1_Q37_DATE",
                    def: "TEACHER_PT1_Q37_DATE",
                  })}
                  rules={inputRequiredBasicRule}
                >
                  <Input
                    type={applyPdfStyles ? undefined : "date"}
                    max={
                      applyPdfStyles
                        ? undefined
                        : disableFutureDates_on_input_date_max()
                    }
                    disabled={disabled}
                    onChange={(e) =>
                      handleFieldChange("TEACHER_PT1_Q46", e.target.value)
                    }
                    id={applyPdfStyles ? "affidavit_input" : ""}
                  />
                </Form.Item>
              )}
            </Col>
          </Row>

          {applyPdfStyles ? (
            <Row className='QuestionsSubSection'>
              <Col
                xs={24}
                lg={12}
                xl={8}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    minWidth: "max-content",
                  }}
                >
                  <span style={{ minWidth: "max-content" }}>
                    {Text({
                      tid: "TEACHER_PT1_Q37_SIGNATURE",
                      def: "Signature of CEO",
                    })}
                  </span>
                  <Form.Item style={{ marginBottom: 0, flex: 1 }}>
                    <Input id={applyPdfStyles ? "affidavit_input" : ""} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          ) : null}
        </div>
        <div className='affidavitSection'>
          {!disabled && (
            <Row className='mb-15 QuestionsSubSection'>
              <Button
                type='default'
                onClick={() =>
                  handleGeneratePDF(
                    "tch_form2_ceo_affidavit",
                    "teacher_form2_ceo_affidavit"
                  )
                }
                className='downloadAffidavitButton'
              >
                {Text({
                  tid: "DOWNLOAD_AFFIDAVIT",
                  def: "Download affidavit",
                })}
              </Button>
            </Row>
          )}
          {/* 36) Institution Head's Signature*/}
          <Row className=' QuestionsSubSection'>
            <Col
              sm={24}
              lg={12}
              xl={8}
            >
              <Form.Item
                name='TEACHER_PT1_Q42'
                label={Text({
                  tid: "UPLOAD_AFFIDAVIT",
                  def: "Upload affidavit",
                })}
                rules={[
                  {
                    required:
                      ceoSignId ||
                      (documentsData?.length &&
                        documentsData.find(
                          (doc: any) => doc.labelName === "TEACHER_PT1_Q42"
                        ))
                        ? false
                        : true,
                    message: Text({ tid: "REQUIRED", def: "Required" }),
                  },
                ]}
              >
                <Input
                  type='file'
                  disabled={disabled}
                  // onChange={(e) => {
                  //   if (e.target.files && e.target.files[0]) {
                  //     uploadDocument(
                  //       e.target.files[0],
                  //       eDocType.OTHER,
                  //       "TEACHER_PT1_Q42"
                  //     );
                  //   }
                  // }}
                  accept='.jpg,.jpeg,.png,.pdf'
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (!validateFile(file as File).valid) {
                      onShowToast({
                        type: ToastType.error,
                        title: <CloseOutlined />,
                        position: ToastOpen.leftBottom,
                        content: validateFile(file as File).error,
                      });
                      e.target.value = "";
                      form.resetFields(["TEACHER_PT1_Q42"]);
                    } else if (file) {
                      uploadDocument(file, eDocType.OTHER, "TEACHER_PT1_Q42");
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              {ceoSignId ? (
                <div className='previewLink'>
                  <span>
                    {Text({
                      tid: "ATTACHED_DOCUMENT",
                      def: "Attached Document",
                    })}
                    :
                  </span>
                  <a
                    href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${ceoSignId}`}
                    target='_blank'
                    rel='noreferrer'
                    className='primary-link'
                  >
                    {Text({
                      tid: "PREVIEW",
                      def: "Preview",
                    })}
                  </a>
                </div>
              ) : (
                documentsData &&
                documentsData?.length > 0 &&
                documentsData
                  .filter((doc: any) => doc.labelName === "TEACHER_PT1_Q42")
                  .map((doc: any) => (
                    <div className='previewLink'>
                      <span>
                        {Text({
                          tid: "ATTACHED_DOCUMENT",
                          def: "Attached Document",
                        })}
                        :
                      </span>
                      <a
                        href={`${process.env.REACT_APP_PUBLIC_API_MEDIA_BASEURL}${doc.docPath}`}
                        target='_blank'
                        rel='noreferrer'
                        className='primary-link'
                      >
                        {doc.docName}
                      </a>
                    </div>
                  ))
              )}
            </Col>
          </Row>
        </div>
        {/* Button Submit */}
        <Row
          style={
            disabled === true
              ? { marginTop: "var(--bs-item-negative-margin-30)" }
              : undefined
          }
        >
          {disabled === false && (
            <Button
              block
              type='primary'
              htmlType='submit'
              disabled={isLoading || disabled || isUploading}
              className='formSubmitButton'
              loading={isSubmitting}
            >
              {Text({ tid: "SUBMIT", def: "SUBMIT" })}
            </Button>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default TeacherPartOne;
